module.exports = __webpack_public_path__ + "img/qiu360you.11988da4.png";